import { OTHER_DIMENSION } from './dimensions';

/**
 * Categorical palette for dimension segments. Brands draw from the `--color-*-600/500`
 * primitives (`utils/brandColor`); dimensions draw from the app's separate `--series-*`
 * semantic palette instead, so a channel is never mistaken for a brand even when both
 * appear on the same page. `Other` always takes the neutral series slot, whatever its rank.
 */
export const DIMENSION_COLOR_TOKENS: string[] = [
  'var(--series-1)',
  'var(--series-2)',
  'var(--series-3)',
  'var(--series-4)',
  'var(--series-5)',
  'var(--series-6)',
  'var(--series-7)',
  'var(--series-8)',
];

export const OTHER_DIMENSION_COLOR = 'var(--series-other)';

export function dimensionColor(dimension: string, ordered: string[]): string {
  if (dimension === OTHER_DIMENSION) return OTHER_DIMENSION_COLOR;
  const index = ordered.indexOf(dimension);
  if (index < 0) return OTHER_DIMENSION_COLOR;
  return DIMENSION_COLOR_TOKENS[index % DIMENSION_COLOR_TOKENS.length];
}
